<template>
  <div class="identify-result">
    <van-overlay :show="dialogVisible">
      <div class="wrapper">
        <div class="content">
          <div v-if="type === 'rebind'" class="result-top">
            <div v-if="result === 'success'">
              <img :src="rebindSuccessImg" alt="" class="result-img">
              <div class="result-text">绑定成功</div>
            </div>
            <div v-if="result === 'failed'">
              <img :src="rebindFail" alt="" class="result-img">
              <div class="result-text">绑定失败</div>
            </div>

          </div>
          <div v-if="type === 'unbound'" class="result-top">
            <div v-if="result === 'success'">
              <img :src="unboundSuccessImg" alt="" class="result-img">
              <div class="result-text">解绑成功</div>
            </div>
            <div v-if="result === 'failed'">
              <img :src="unboundFailImg" alt="" class="result-img">
              <div class="result-text">解绑失败</div>
            </div>
          </div>
          <van-button type="primary" class="close-btn" round color="linear-gradient(120deg, #000 0%, #000 97%)" @click.stop="close">确定</van-button>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: 'IdentifyResult',
  props: {
    type: {
      type: String,
      default: ''
    },
    result: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rebindSuccessImg: require('@/assets/images/rebind_success.png'),
      rebindFail: require('@/assets/images/rebind_failed.png'),
      unboundSuccessImg: require('@/assets/images/unbound_success.png'),
      unboundFailImg: require('@/assets/images/unbound_failed.png')
    }
  },
  methods: {
    close() {
      // 关闭弹框
      this.$emit('closeDialog')
      // 如果是成功，则返回上一页
      if (this.result === 'success') {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.identify-result {
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .content {
      position: relative;
      width: 619px;
      height: 478px;
      background-image: linear-gradient(180deg, #CCDDFF 0%, #FFFFFF 36%);
      border-radius: 16px;
      .result-top{
        position: relative;
        top: -139px;
        left: 50%;
        margin-left: -171px;
        width: 342px;
        .result-img {
          width: 342px;
          height: 342px;
        }
        .result-text {
          font-size: 36px;
          color: #212026;
          text-align: center;
          font-weight: 500;
          margin-top: 12px;
        }
      }
      .close-btn {
        position: absolute;
        font-size: 32px;
        bottom: 37px;
        left: 36px;
        width: 542px;
        height: 96px;
      }

    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/bind/components/identify-result.vue